"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconLinkExternal = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconLinkExternal = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M22.91 0h-8.728a1.09 1.09 0 10-.001 2.18h6.094L9.047 13.395a1.088 1.088 0 00.771 1.86c.28 0 .559-.107.771-.32L21.82 3.72v6.087a1.09 1.09 0 102.181 0V1.09A1.091 1.091 0 0022.91 0z"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M18.545 10.897a1.09 1.09 0 00-1.09 1.09v9.807H2.182V6.538H12a1.09 1.09 0 100-2.18H1.09A1.09 1.09 0 000 5.448v17.436c0 .602.488 1.09 1.09 1.09h17.455a1.09 1.09 0 001.091-1.09V11.987a1.09 1.09 0 00-1.09-1.09z"
}));
exports.IconLinkExternal = IconLinkExternal;
//# sourceMappingURL=IconLinkExternal.js.map